export default {
    edit: 'संपादित करें',
    delete: 'हटाना',
    save: 'Save',
    reset: 'Reset',
    update: 'Update',
    create: 'सर्जन करना',
    cancel: 'Cancel',
    menu: 'Menu',
    manage_menu: 'Manage Menu',
    id: 'ID',
    title: 'Title',
    icon: 'Icon',
    remark: 'Remark',
    url: 'URL',
    status: 'Status',
    operations: 'Operations',
    manage_roles: 'Manage Roles',
    date: "Date",
    name: "Name",
    permission: "Permission",
    add_role: "Add Role",
    edit_role: "Edit Role",
    check_all: "Check all",
    confirm: "Confirm",
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    DOB: "Date of birth",
    edit_user: "Edit User",
    gender: "Gender",
    male: "Male",
    female: "Female",
    email_address: "Email Address",
    manage_users: 'Manage Users',
    Manage_permissions: "Manage Permissions",
    add_permission: "Add Permission",
    edit_permission: "Edit Permission",
    display_name: "Display Name",
    calendar: "Calendar",
    general_settings: "General Settings",
    admin_email: "Admin Email",
    timezone: "Timezone",
    date_format: "Date Format",
    time_format: "Time Format",
    logo_upload: "Logo Upload",
    create_menu: "Create Menu",
    edit_menu: "Edit Menu",
    menu_title: "Menu Title",
    menu_icon: "Menu Icon",
    select_parent: "Select Parent",
    category: "Category",
    menu_status: "Menu status",
    display_order: "Order Number",
    enable: "Enable",
    disable: "Disable",
    updated_at: "Modified at",
    parent_name: "Parent name",
    search: "Search",
    '24h': "Use 24h clock",
    '12h': "Use 12h clock",
    select_timezone: "Select Timezone",
    select_date_format: "Select date format",
    select_time_format: "Select Time Format",
    select_language: "Select language",
    select_currency: "Select currency",
    admin_email_required: "Please input admin email address",
    admin_email_invalid: "Please input valid email address",
    menu_title_required: "Please input menu title",
    language: "Language",
    currency: "Currency"
}



// WEBPACK FOOTER //
// ./src/assets/lan/hi.js